export default __webpack_public_path__ + "static/media/5a.e60fc784.jpg";